import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'
import Desc from '../views/Desc.vue'
import Pc360 from '../views/Pc360.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'index',
    component: Index
  },
  {
    path: '/desc',
    name: 'desc',
    component: Desc
  }, {
    path: '/pc360',
    name: 'pc360',
    component: Pc360
  }
]

function getBase() {
  let url = window.location.href.replace("//", "");
  let urls = url.split("/");
  let rurl = "/";
  if (urls.length > 1 && urls[1]) {
    for (let index = 1; index < 2; index++) {
      const url = urls[index];
      rurl += (url + "/")
    }
  }
  if (url.indexOf("/web/app") > -1) {
    rurl = "/web/app/"
  }
  // console.log(rurl);
  return rurl;
}

const router = new VueRouter({
  mode: 'history',
  base: getBase(),
  routes
})

export default router